import React from "react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatError, formatRupiah } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import StatusBadge from "@/components/StatusBadge";

export default function Withdraw() {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({ amount: 10, bank_name: "", account_no: "", account_name: "" });
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = () => api.get("/withdraw/mine").then((r) => setHistory(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/withdraw/request", { ...form, amount: Number(form.amount) });
      toast.success("Permintaan tarik dana dibuat. Menunggu approval admin.");
      setForm({ ...form, amount: 10 });
      await refresh();
      load();
    } catch (err) { toast.error(formatError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8 py-10" data-testid="withdraw-page">
      <div className="label-mono text-zinc-500">// CASH OUT</div>
      <h1 className="font-display text-4xl md:text-5xl font-black uppercase mt-1">Tarik Dana</h1>
      <div className="mt-2 font-mono text-xs text-zinc-600">Saldo tersedia: <b>{formatRupiah(user?.balance || 0)}</b></div>

      <div className="mt-6 grid lg:grid-cols-2 gap-6">
        <form onSubmit={submit} className="border border-black bg-white p-6 shadow-brutal">
          <div className="label-mono text-zinc-500">// FORM</div>
          <h2 className="font-display text-xl font-black uppercase mt-1 mb-4">Permintaan</h2>

          <label className="label-mono block mb-2">Jumlah ($)</label>
          <input type="number" min={5} step={0.01} value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} className="input-brutal mb-4" required data-testid="wd-amount" />

          <label className="label-mono block mb-2">Bank / E-Wallet</label>
          <input value={form.bank_name} onChange={(e) => setForm({ ...form, bank_name: e.target.value })} className="input-brutal mb-3" placeholder="Wise / Payoneer / Bank" required data-testid="wd-bank" />

          <label className="label-mono block mb-2">No. Rekening / Account ID</label>
          <input value={form.account_no} onChange={(e) => setForm({ ...form, account_no: e.target.value })} className="input-brutal mb-3" required data-testid="wd-acc-no" />

          <label className="label-mono block mb-2">Nama Pemilik Rekening</label>
          <input value={form.account_name} onChange={(e) => setForm({ ...form, account_name: e.target.value })} className="input-brutal mb-6" required data-testid="wd-acc-name" />


          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="wd-submit">
            {loading ? "// PROCESSING..." : "Ajukan Penarikan →"}
          </button>
        </form>

        <div className="border border-black bg-white">
          <div className="p-4 border-b border-black label-mono">// HISTORY</div>
          {history.length === 0 ? (
            <div className="p-8 text-center font-mono text-xs text-zinc-500">// Belum ada penarikan</div>
          ) : (
            history.map((h) => (
              <div key={h.id} className="p-4 border-b border-zinc-200" data-testid={`wd-history-${h.id}`}>
                <div className="flex justify-between items-start">
                  <div>
                    <div className="font-mono text-sm font-bold">{formatRupiah(h.amount)}</div>
                    <div className="text-[10px] font-mono text-zinc-500 mt-1">{h.bank_name} · {h.account_no}</div>
                    <div className="text-[10px] font-mono text-zinc-500">{h.account_name}</div>
                  </div>
                  <StatusBadge status={h.status} />
                </div>
                <div className="text-[10px] font-mono text-zinc-500 mt-2">{new Date(h.created_at).toLocaleString("en-US")}</div>
                {h.note && <div className="text-[11px] font-mono mt-1 italic">"{h.note}"</div>}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

